export { default as DID } from './lib/did.js';
export { default as DIDRecoverable } from './lib/didrecoverable.js';
export { getResolver as Resolver } from './lib/resolver.js';